export default __webpack_public_path__ + "static/aeroFIX_RWF-4458babc47ba1ec8f57ca0be46edfc95.jpg";